import { useContent } from '@/content';

const icons = ['ri-heart-fill', 'ri-sparkling-fill', 'ri-shield-check-fill'];

export default function PhilosophySection() {
  const c = useContent();
  return (
    <section className="py-20 md:py-28 bg-blush-50/50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14 animate-on-scroll">
          <p className="text-xs tracking-[0.3em] uppercase text-champagne-500 font-medium mb-3">
            {c.philosophy.eyebrow}
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-800 mb-6">
            {c.philosophy.title}
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-gray-600 leading-relaxed text-sm md:text-base">
              {c.philosophy.intro1}
            </p>
            <p className="text-gray-600 leading-relaxed text-sm md:text-base mt-4">
              {c.philosophy.intro2}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {c.philosophy.cards.map((item, index) => (
            <div
              key={index}
              className={`animate-on-scroll delay-${(index + 1) * 150} bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-blush-100 hover:shadow-md hover:-translate-y-1 transition-all duration-300`}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-champagne-50 mb-5">
                <i className={`${icons[index] ?? icons[0]} text-champagne-500 text-xl`}></i>
              </div>
              <h3 className="font-display text-xl text-gray-800 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}